import { createContext } from 'react'

import type { AlertStatusesContextValue } from '../types'

export type { AlertStatusesContextValue, StatusRecord } from '../types'

const AlertStatusesContext = createContext<AlertStatusesContextValue | undefined>(undefined)

export default AlertStatusesContext
